export default __webpack_public_path__ + "static/media/circle.69d6435c.svg";